import React from 'react';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

const PublicRoute = ({ children, redirectIfAuthenticated = true }) => {
  const token = Cookies.get('token');
  const location = useLocation();


  if (token && redirectIfAuthenticated) {
    // return <Navigate to='/' replace state={{ from: location }} />;
    return <Navigate to='/cx' replace state={{ from: location }} />;
  }

  if (!location.pathname.startsWith('/exchange-profile') && !location.pathname.startsWith('/cx') && !location.pathname.startsWith('/password-recovery')) {
    return <Navigate to='/cx' replace />;
  }
  // if (location.pathname === '/v2/signup') {
  //   return <Navigate to='/login' replace />;
  // }

  return children;
};

PublicRoute.propTypes = {
  children: PropTypes.node.isRequired,
  redirectIfAuthenticated: PropTypes.bool
};

export default PublicRoute;
